import * as React from 'react';
import Box from 'apollo-react/components/Box';
import TextField from 'apollo-react/components/TextField';
import Info from 'apollo-react/icons/Info';
import { useTranslation } from 'react-i18next';
import './common.css';
export default function OTP({ separator, length, value, onChange }) {
  const { t } = useTranslation();
  const inputRefs = React.useRef(new Array(length).fill(null));

  const focusInput = (targetIndex) => {
    const targetInput = inputRefs.current[targetIndex];
    targetInput?.focus();
  };

  const selectInput = (targetIndex) => {
    const targetInput = inputRefs.current[targetIndex];
    targetInput?.select();
  };

  const handleKeyDown = (event, currentIndex) => {
    switch (event.key) {
      case 'ArrowUp':
      case 'ArrowDown':
      case ' ':
        event.preventDefault();
        break;
      case 'ArrowLeft':
        event.preventDefault();
        if (currentIndex > 0) {
          focusInput(currentIndex - 1);
          selectInput(currentIndex - 1);
        }
        break;
      case 'ArrowRight':
        event.preventDefault();
        if (currentIndex < length - 1) {
          focusInput(currentIndex + 1);
          selectInput(currentIndex + 1);
        }
        break;
      case 'Delete':
      case 'Backspace':
        event.preventDefault();
        if (event.key === 'Backspace' && currentIndex > 0) {
          focusInput(currentIndex - 1);
          selectInput(currentIndex - 1);
        }
        onChange((prevOtp) => {
          const otp =
            prevOtp.slice(0, currentIndex) + prevOtp.slice(currentIndex + 1);
          return otp;
        });
        break;
      default:
        break;
    }
  };

  const handleChange = (event, currentIndex) => {
    const currentValue = event.target.value;

    // Only allow numeric input
    const numericValue = currentValue.replace(/[^0-9]/g, '');
    if (currentValue !== '' && numericValue === '') {
      return; // Reject non-numeric input
    }

    let indexToEnter = 0;

    while (indexToEnter <= currentIndex) {
      if (
        inputRefs.current[indexToEnter].value &&
        indexToEnter < currentIndex
      ) {
        indexToEnter += 1;
      } else {
        break;
      }
    }

    onChange((prev) => {
      const otpArray = prev.split('');
      const lastValue = numericValue[numericValue.length - 1];
      otpArray[indexToEnter] = lastValue;
      return otpArray.join('');
    });

    if (numericValue !== '' && currentIndex < length - 1) {
      focusInput(currentIndex + 1);
    }
  };

  const handleClick = (_, currentIndex) => {
    selectInput(currentIndex);
  };

  const handlePaste = (event, currentIndex) => {
    event.preventDefault();
    const clipboardData = event.clipboardData;
    if (clipboardData.types.includes('text/plain')) {
      // Only allow numeric characters from pasted text
      const pastedText = clipboardData
        .getData('text/plain')
        .replace(/[^0-9]/g, '')
        .substring(0, length)
        .trim();

      if (!pastedText) return; // Nothing valid to paste

      let indexToEnter = 0;

      while (indexToEnter <= currentIndex) {
        if (
          inputRefs.current[indexToEnter].value &&
          indexToEnter < currentIndex
        ) {
          indexToEnter += 1;
        } else {
          break;
        }
      }

      const otpArray = value.split('');

      for (let i = indexToEnter; i < length; i += 1) {
        const lastValue = pastedText[i - indexToEnter] ?? ' ';
        otpArray[i] = lastValue;
      }

      onChange(otpArray.join(''));
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center', // Center the whole block horizontally
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
        }}
      >
        <span
          style={{
            lineHeight: '21px',
            marginLeft: '3px',
            textAlign: 'left',
          }}
        >
          {t('otp.emailOtpLabel')}{' '}
          <Info fontSize="extraSmall" style={{ color: '#595959' }} />
        </span>

        <Box
          sx={{
            display: 'flex',
            gap: 1,
          }}
          className="otp-wrapper"
        >
          {new Array(length).fill(null).map((_, index) => (
            <TextField
              key={index}
              variant="standard"
              margin="none"
              label=""
              helperText={null}
              fullWidth={false}
              InputProps={{
                inputRef: (ele) => {
                  inputRefs.current[index] = ele;
                },
                onKeyDown: (e) => handleKeyDown(e, index),
                onClick: (e) => handleClick(e, index),
                onPaste: (e) => handlePaste(e, index),
                className: 'otp-input',
                autoComplete: 'off',
              }}
              InputLabelProps={{ shrink: false }}
              value={value[index] ?? ''}
              onChange={(e) => handleChange(e, index)}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
